import React from "react";
import "@/chunkReload"; // must run before any React.lazy page is declared
import ReactDOM from "react-dom/client";
// Fonts are self-hosted (no Google Fonts request; see /legal/cookies).
import "@fontsource-variable/plus-jakarta-sans";
import "@fontsource-variable/newsreader/opsz.css";
import "@fontsource-variable/newsreader/opsz-italic.css";
import "@fontsource-variable/jetbrains-mono";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
